// Module
var code = "<text-editor id=\"{{ componentId }}-{{ index }}\" class=\"editor form-control\" ng-model=\"data[component.key][index].name\" ng-disabled=\"readOnly || component.disabled\" ng-model-options=\"{ allowInvalid: true }\" ng-required=\"isRequired(component)\" ng-attr-name=\"{{ componentId }}-{{ index }}\" ng-change=\"changeValue()\"></text-editor> ";
// Exports
export default code;